module.exports = __webpack_public_path__ + "img/img_main.002e60bd.jpg";